import { styled, useTheme } from "styled-components";
import ReactLoading from "react-loading";

export default function Loading() {
  const theme = useTheme();

  return (
    <Container>
      <ReactLoading type="spin" color={theme.colors.primary} height="10%" width="10%" />
    </Container>
  );
}

const Container = styled.main`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.white};
`;